import { ShareAmount } from "@/services/cloudchipr.api";

export const generateShareAmountsForSharedCost = (
  ids: string[],
): ShareAmount[] => {
  const n = ids.length;

  if (n <= 0 || n > 100) {
    return [];
  }

  const base = Math.floor(100 / n);
  const remainder = 100 - base * n;

  return ids.map((id, index) => ({
    category_id: id,
    share_amount: base + (index === n - 1 ? remainder : 0),
  }));
};
